import { get, post } from './api'
export default {
    data() {
        return {
            settingsLoader: false,
            applicationName: 'ladytroc',
            appTechName: 'ladytroc',
            plateformName: 'ladytroc',
            simplePlateformName: 'ladytroc',
            defaultPercentageMath: 0.2,
            defaultPercentageText: 20,
            defaultValidity: 30,
            appContact: `TEL: 12 121 221 | EMAIL contact@ladytroc.tn`,
            isPriceIncluded: false,
            updatedSetti: 0
        }
    },
    computed: {
        appLogo() {
            return `https://api.${this.appTechName}.tn/public/logo.png`
            // return `http://localhost:3000/static/logo.png`
        }
    },
    methods: {
        updateSettings(form) {
            this.settingsLoader = true
            post('settings', form).then(() => {
                this.defaultPercentageMath = parseInt(form.defaultPercentage + '') / 100
                this.applicationName = form.appName
                this.simplePlateformName = form.appName
                this.defaultPercentageText = form.defaultPercentage
                this.defaultValidity = form.defaultValidity
                this.appContact = form.appContact
                this.appTechName = form.appTechName
                this.isPriceIncluded = form.isPriceIncluded == 1
            })
                .finally(() => {
                    this.settingsLoader = false
                })
        },
        getSettings() {
            this.settingsLoader = true
            get('settings').then((res) => {
                const form = res.data.data
                this.defaultPercentageMath = parseInt(form.defaultPercentage + '') / 100
                this.applicationName = form.appName
                this.simplePlateformName = form.appName
                this.exceptionPlateformName =form.appName
                this.defaultPercentageText = form.defaultPercentage
                this.defaultValidity = form.defaultValidity
                this.appContact = form.appContact
                this.appTechName = form.appTechName
                this.isPriceIncluded = form.isPriceIncluded == 1
                this.updatedSetti++
            })
                .finally(() => {
                    this.settingsLoader = false
                })
        }
    },
    mounted() {
        this.getSettings()
    }
}